// extracted by mini-css-extract-plugin
export default {"stack":"v06y4dnoJ4D_w8YtBObQ"};